window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
require('popper.js');

import 'bootstrap';
import Vue from 'vue'
import axios from 'axios'
import * as dateFormat from 'date-fns/format'

window.app = new Vue({
  el: '#website',
  data: {
    mainVisualLoaded: false,
    sectionActive: {},
    sectionSlideIndex: 0,
    scrollTop: (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0),
    windowHeight: window.innerHeight,
    navbarCollapseShown: false,
    categories: [],
    posts: [],
    newsPage: 0,
    newsFetching: false,
  },
  computed: {
    navbarActive() {
      if ($('body').hasClass('home')) {
        let activeTop = 0
        let { mainVisual } = this.$refs
        if (mainVisual) {
          activeTop += mainVisual.offsetTop + mainVisual.clientHeight
        }
        return this.scrollTop > activeTop || this.navbarCollapseShown
      } else {
        return true;
      }
    },
    navbarCollapseHeight() {
      return this.windowHeight - 64
    },
    toTopActive() {
      return this.scrollTop > window.innerHeight * 0.25 && this.navbarCollapseShown == false
    },
    toTopStop() {
      let stopTop = 0
      let { main } = this.$refs
      if (main) {
        stopTop += main.offsetTop + main.clientHeight - window.innerHeight
      }
      return this.scrollTop > stopTop
    },
    jsonApi() {
      let linkTag = Array.from(document.head.getElementsByTagName('link'))
      let apiLinkTag = linkTag.find(link => link.rel == 'https://api.w.org/')
      return apiLinkTag ? apiLinkTag.href : null
    },
    canNextPosts() {
      return this.totalPosts > 13 + this.posts.length || this.categories.length == 0
    },
  },
  watch: {
    scrollTop(scrollTop) {
      $('.section-slide').each((i, element) => {
        let rect = element.getBoundingClientRect()
        $(element).toggleClass('slide-in', rect.top <= 0)
        $(element).toggleClass('slide-out', rect.bottom <= window.innerHeight)
        if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
          let $slides = $(element).find('.section-slide-item')
          this.sectionSlideIndex = Math.floor(Math.abs(rect.top) / (rect.height / ($slides.length + 1)))
        }
      })
    },
  },
  mounted() {
    $(window).on('scroll', e => {
      this.scrollTop = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
    })
    $(window).on('resize', e => {
      this.resizeYouTubeVideo()
      this.windowHeight = window.innerHeight
    })
    this.resizeYouTubeVideo()
    $('.navbar-header .collapse').on('show.bs.collapse', e => {
      this.navbarCollapseShown = true
    }).on('hide.bs.collapse', e => {
      this.navbarCollapseShown = false
    })
    if ($('#mainVisualVideo').length > 0) {
      this.loadYouTubeVideo()
    }
    $('.section-slide').each((i, element) => {
      $(element).css('height', $(element).find('.section-slide-item').length * 100 + 'vh')
    })
    $('.form-control').each((i, element) => {
      if ($(element).next().is('.error-message')) {
        $(element).addClass('is-invalid')
      }
    })
    $('.carousel-numbers[data-target]').each((i, element) => {
      let $numbers = $(element)
      let $carousel = $($numbers.data('target'))
      if ($carousel.length > 0) {
        let $items = $carousel.find('.carousel-item')
        $numbers.text(($items.index($carousel.find('.carousel-item.active')) + 1) + ' / ' + $items.length)
        $carousel.on('slid.bs.carousel', () => {
          $numbers.text(($items.index($carousel.find('.carousel-item.active')) + 1) + ' / ' + $items.length)
        })
      }
    })
  },
  // computed: {},
  methods: {
    loadYouTubeVideo() {
      let tag = document.createElement('script')
      tag.src = "https://www.youtube.com/iframe_api"
      let firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      let player = null
      window.onYouTubeIframeAPIReady = () => {
        player = new YT.Player('mainVisualVideo', {
          videoId: 'eFHo_jdtTBE',
          playerVars: {
            autoplay: 1,
            color: 'white',
            controls: 0,
            disablekb: 1,
            enablejsapi: 1,
            iv_load_policy: 3,
            // loop: 1,
            // playlist: 'eFHo_jdtTBE',
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            showinfo: 0,
          },
          events: {
            onReady: e => {
              e.target.mute()
              e.target.playVideo()
            },
            onStateChange: e => {
              if (e.data == YT.PlayerState.PLAYING) {
                this.mainVisualLoaded = true
              }
              if (e.data == YT.PlayerState.ENDED) {
                e.target.playVideo()
              }
            },
            onError: e => {
              this.mainVisualLoaded = false
            },
          },
        })
      }
    },
    resizeYouTubeVideo() {
      var $w = $(window),
          bw = 1200, //基準にする横幅
          bh = (bw/16) * 9, //基準にする高さ(16:9)
          w = $w.width(), //表示サイズ(幅)
          h = $w.height(), //表示サイズ(高さ)
          mw = w, //動画サイズ(幅)
          mh =  Math.round(bh * (mw/bw)); //動画サイズ(高さ)
      if ( mh < h ) { //動画の高さが表示サイズの高さより小さかったら
          mh = h; //表示サイズの高さに変更
          mw = Math.round(bw * (mh/bh)); //高さに合わせて横幅変更
      }
      $('#mainVisualVideo').css({
          width: mw,
          height: mh,
          marginTop: (h - mh)/2,
          marginLeft: (w - mw)/2
      });
    },
    sectionFocus(key) {
      this.$set(this.sectionActive, key, true)
    },
    sectionBlur(key) {
      this.$set(this.sectionActive, key, false)
    },
    scrollSectionSlide(i) {
      let scrollTop = this.$refs.mainVisual.clientHeight + window.innerHeight * i
      $('html,body').animate({ scrollTop }, 'fast');
    },
    scrollToTop() {
      $('html,body').animate({ scrollTop: 0 }, 'fast');
    },
    fetchCategories() {
      if (this.categories.length == 0) {
        return axios.get('/wp/v2/categories', {
          baseURL: this.jsonApi,
        })
        .then(response => {
          response.data.forEach(term => {
            this.categories.push(term)
          })
        })
      } else {
        return Promise.resolve()
      }
    },
    fetchPosts() {
      return axios.get('/wp/v2/posts?_embed', {
        baseURL: this.jsonApi,
        params: {
          offset: 13 + ((this.newsPage-1) * 8),
          per_page: 8,
        }
      }).then(response => {
        this.totalPosts = parseInt(response.headers['x-wp-total'])
        response.data.forEach(post => {
          let { _embedded } = post
          let thumb = null
          if (_embedded['wp:featuredmedia'] && _embedded['wp:featuredmedia'].length > 0) {
            thumb = _embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url
          }
          this.posts.push({
            id: post.id,
            date: dateFormat(post.date, 'YYYY年M月D日'),
            title: post.title.rendered,
            permalink: post.link,
            categories: post.categories.map(termId => this.categories.find(term => term.id == termId)),
            thumb,
          })
        })
      })
    },
    getNextPosts() {
      if (this.jsonApi && this.newsFetching == false) {
        this.newsFetching = true
        this.newsPage++
        this.fetchCategories()
          .then(this.fetchPosts())
          .finally(() => {
            this.newsFetching = false
          })
      }
    },
  },
})



// WEBPACK FOOTER //
// ./js/src/app.js